/**
 * 应用管理（第三方应用配置）
 * 需要在 src/router/router.js 引入并加入 BasicLayout 的 children
 */

export default {
  path: 'mini_app/list',
  name: 'mini_app',
  component: () => import('@/pages/mini_app/MiniAppList'),
  meta: { title: '应用管理' }
}
